import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import parse from 'html-react-parser';
import { sanitizeHtml } from 'components/sanitizeHtml';
import useTranslate from 'hooks/useTranslate';
import { useGetHomeVideosQuery } from 'services';
import { S3_URL, convertSeconds } from 'constants/index';
import { setModalConfig } from 'store/common';
import './styles.scss';
import IntroStassifySliderItem from './IntroStassifySliderItem';

const IntroStassify: React.FC = () => {
	const { data: { slider = [] } = {} } = useGetHomeVideosQuery();
	const settings = {
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		className: 'center',
		centerMode: true,
		centerPadding: '18%',
		cssEase: 'linear',
		accessibility: true,
		focusOnSelect: false,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					centerPadding: '10%',
				},
			},
		],
	};
	const { translate } = useTranslate();

	const [sliderData, setSliderData] = useState<any[]>([]);

	useEffect(() => {
		if (slider?.length > 0) {
			setSliderData(
				slider?.map((data: any) => {
					return {
						mediaType: 'video',
						file: data?.banner_video,
						videoThumbnail: S3_URL + data?.banner_video_thumb,
						title: data?.title,
						banner_video_duration: data?.banner_video_duration,
						duration: convertSeconds(data?.banner_video_duration),
					};
				}) || [],
			);
		}
	}, [slider]);

	const onAssetsClick = (index: number) => {
		setModalConfig({
			visible: true,
			data: sliderData,
			id: index,
			type: 'carouselModal',
			props: {
				fullscreen: true,
				centered: true,
				dialogClassName: 'dialog-assets-carousel',
			},
		});
	};

	return (
		<section className="intro-stassify py-80">
			<div className="main-heading px-3 text-center mx-auto">
				<h2 className="fw-bold">{parse(sanitizeHtml(translate('Home.introStassify')))}</h2>
				<p className="mb-0">{translate('Home.introStassifySubTitle')}</p>
			</div>
			<div className="intro-stassify-slider">
				<Slider {...settings} className="w-100 overflow-hidden">
					{sliderData?.length > 0 &&
						sliderData?.map((slideData: any, index: number) => (
							<IntroStassifySliderItem
								key={index}
								slideData={slideData}
								onPlay={() => onAssetsClick(index)}
							/>
						))}
				</Slider>
			</div>
		</section>
	);
};

export default IntroStassify;
